__turbopack_context__.v({
  "divider": "work-purchased-message-module-scss-module__953bBW__divider",
  "icon": "work-purchased-message-module-scss-module__953bBW__icon",
  "message": "work-purchased-message-module-scss-module__953bBW__message",
  "root": "work-purchased-message-module-scss-module__953bBW__root",
  "u-animation-bounce": "work-purchased-message-module-scss-module__953bBW__u-animation-bounce",
});
